import { useCallback, useState } from 'react';
import { useCreateCollection } from './useCollection';
import { CollectionConfigWithConditionals } from './collectionConfigPartials';
import { FiltersMap, OptionalFiltersMap } from '../model';
import { PickerState } from '../state';
import { useWixPatternsContainer } from '../providers';

export type PickerConfig<
  T,
  F extends FiltersMap,
> = CollectionConfigWithConditionals<T, F>;
export type PickerFactory = <T, F extends FiltersMap>(
  config: PickerConfig<T, F>,
) => PickerState<T, F>;

export function useCreatePicker(): PickerFactory {
  const { createBILogger } = useWixPatternsContainer();
  const createCollection = useCreateCollection();

  return useCallback<PickerFactory>((config) => {
    const { events, ...collectionConfig } = config;

    const collection = createCollection({
      ...collectionConfig,
      events,
    });

    return new PickerState({
      getMaxItems: () => undefined,
      collection,
      events,
      reportBi: createBILogger({
        ...collection.fqdn,
      }),
    });
  }, []);
}

export function usePicker<T, F extends FiltersMap = OptionalFiltersMap>(
  config: PickerConfig<T, F>,
): PickerState<T, F> {
  const createPickerStandalone = useCreatePicker();

  const [state] = useState(() => createPickerStandalone<T, F>(config));

  return state;
}
